import React from 'react';
import styles from './OptionsContainer.module.scss';

interface CustomCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`${styles.customCheckbox} ${checked ? styles.active : ''} ${
        disabled ? styles.disabled : ''
      }`}
    >
      <div className={styles.customCheckboxLabel}>
        {checked ? (
          label
        ) : (
          <span className={styles.spanContainer}>{label}</span>
        )}
      </div>
    </div>
  );
};

export default CustomCheckbox;
